import "./VoucherForm.css";
import { useState } from "react";

function VoucherForm({ onSubmit }) {
  const [voucherCode, setVoucherCode] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit === "function") {
      onSubmit({
        voucherCode: voucherCode.trim()
      });
    }
  };

  return (
    <form className="voucher-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="voucherCode">Voucher Code</label>
        <input
          type="text"
          id="voucherCode"
          value={voucherCode}
          onChange={(e) => setVoucherCode(e.target.value)}
          placeholder="Enter voucher code"
          required
        />
      </div>

      <button className="primary-action" type="submit">
        Submit
      </button>
    </form>
  );
}

export default VoucherForm;
